import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tag.css';

class Tag extends Component {
	constructor(props) {
        super(props);
        this.state = {
            isActive: false
        }
	}

	toggleActive = (e) => {
		this.setState({
            isActive: !this.state.isActive
		});
		this.props.handleChangeFilter(e);
	}

	componentDidMount() {
		this.setState({
            isActive: this.props.isActive
		});
	}

	componentWillReceiveProps() {
		if(this.props.isReset) {
			this.setState({
				isActive: false
			});
		}
	}
	
  	render() {
  		return (
			<button
				className={"showtix-tag " + (this.state.isActive === true ? 'is-active' : '')}
				object={this.props.object}
				name={this.props.name}
				value={this.props.value}
				onClick={this.toggleActive}
				id={this.props.id}
				aria-selected={this.state.isActive}
				aria-label={`Select this tag ${this.props.name}`}
				>
				{this.props.name}
			</button> 
		);
  	}
}

Tag.propTypes = {
    object: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.number,
    id: PropTypes.string,
    isActive: PropTypes.bool,
    handleChangeFilter: PropTypes.func,
}

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Common/Tag/Tag.js